export default __webpack_public_path__ + "fonts/refreshBtnActive.svg";